import { FONT, WEIGHT } from '../../styles/foundation/typography';
import { NAVY, WHITE, PRIMARY_BLUE, ERROR, withOpacity } from '../../styles/foundation/colors';

// Same button treatment as the existing Help & Support page (EscalationManagement/index.js) —
// this module sits right alongside it, so buttons should read as the same product, not a
// visually distinct "V2" skin.
export const gradientBtnSx = {
    fontFamily: FONT, textTransform: 'none', fontWeight: WEIGHT.bold, borderRadius: '10px', px: 2.5,
    background: `linear-gradient(135deg, ${PRIMARY_BLUE} 0%, ${NAVY} 100%)`,
    boxShadow: `0 4px 12px ${withOpacity(PRIMARY_BLUE, 0.35)}`,
    '&:hover': { boxShadow: `0 6px 16px ${withOpacity(PRIMARY_BLUE, 0.45)}` },
};
export const filterBtnSx = {
    fontFamily: FONT, fontSize: '12px', fontWeight: WEIGHT.bold, textTransform: 'uppercase', letterSpacing: '0.5px',
    px: 2.5, py: 1, borderRadius: '8px', bgcolor: PRIMARY_BLUE, '&:hover': { bgcolor: NAVY },
};
export const resetBtnSx = {
    fontFamily: FONT, fontSize: '12px', fontWeight: WEIGHT.bold, textTransform: 'uppercase', letterSpacing: '0.5px',
    px: 2.5, py: 1, borderRadius: '8px', bgcolor: ERROR, color: WHITE, '&:hover': { bgcolor: ERROR, opacity: 0.9 },
};
